import { useQuery, UseQueryResult } from 'react-query';
import { useSelector } from 'react-redux';

import { selectTokenId } from '@redux';
import { getOrgTreeBaseUrl } from '@legacy-modules/common/services/EnvironmentConfigurationService';
import OrgUnitNode from '@legacy-modules/metrics2/models/entities/organization/OrgUnitNode';

type InputParameters = {
  realm: string;
  enabled?: boolean;
};

type OrgTreeQueryResult = {
  node: OrgUnitNode;
};

export default function useOrgTree(parameters: InputParameters): UseQueryResult<OrgTreeQueryResult> {
  const { realm, enabled = true } = parameters;
  const tokenId = useSelector(selectTokenId);
  const url = new URL(`${getOrgTreeBaseUrl()}/orgtree/realm/${realm}`);

  return useQuery<OrgTreeQueryResult>({
    queryKey: ['org-tree', realm],
    queryFn: () =>
      fetch(url, {
        headers: {
          token: tokenId,
        },
      }).then((res) => res.json()),
    enabled: enabled && !!realm,
  });
}
